<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      size="small"
      onsubmit="return false"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_brandName') || '品牌名称'"
            prop="brandName"
          >
            <el-input
              v-model="formData.brandName"
              :placeholder="
                $l('form_placeholder_brandName') || '请输入品牌名称'
              "
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: { custCode: { type: String, default: '' } },
  data() {
    return {
      formData: { brandName: '' },
      rules: {
        brandName: [
          {
            required: true,
            message: this.$l('form_placeholder_brandName') || '请输入品牌名称',
            trigger: 'blur',
          },
          {
            validator: async (rule, value, callback) => {
              if (!value) return callback()

              const res = await this.$api
                .masterBrandExistApi(value)
                .catch(() => null)
              const exist = res?.body || false
              if (exist)
                return callback(
                  new Error(
                    this.$l('tips_brand_isexist') || '该品牌已存在，请检查'
                  )
                )
            },
          },
        ],
      },
    }
  },
  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerBrandSaveApi({
          ...this.formData,
          custCode: this.custCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      this.$emit('reload')
      this.close()
    },
    cancel() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') this.close()
        })
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
